export enum Categories {
  Phones = 'phones',
  Tablets = 'tablets',
  Accessories = 'accessories',
}

export enum SearchParams {
  Sort = 'sort',
  PerPage = 'perPage',
  Query = 'query',
  Page = 'page',
}
